import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { ListItem } from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import SchoolIcon from 'material-ui/svg-icons/social/school';
import LaunchIcon from 'material-ui/svg-icons/action/launch';

import { avatar as avatarColours, statusColours } from '../../constants/ColourConstants';

import BasicProgressBar from '../ProgressBar/BasicProgressBar';

const style = {
    listItem: {
        padding: '2px',
    }
};

const CourseEnrolmentStatsCourseListItem = ({data}) => {

    const infoLink    = `/dashboard/course/${data.courseId}/enrolments`;
    const description = `${data.completed} / ${data.total}  ${data.waiting ? `(${data.waiting} waiting)` : ''}`;

    let listItemProps = {
        key: data.id,
        style: style.listItem,
        secondaryTextLines: 2
    };

    listItemProps.primaryText = (<Link to={infoLink} className="primaryText">{data.name}</Link>);

    listItemProps.secondaryText = (
            <div className="secondaryInfo">
                <BasicProgressBar
                    total={data.total}
                    completed={data.completed}
                    link={infoLink}
                /><em><Link to={infoLink}>{description}</Link></em>
            </div>
        );


    const avatarStyle = (data.waiting || data.enrolled) ? avatarColours.courseDefault : avatarColours.courseCompleted;
    let avatarIcon  = <SchoolIcon />;
    switch(data.courseType) {
        case 'classroom':
            avatarIcon = (<SchoolIcon />);
            break;

        case 'e-learning':
            avatarIcon = (<LaunchIcon />);
            break;

        default:
            break;
    }

    return (
        <ListItem {...listItemProps}
            leftAvatar={
                <Link to={infoLink}>
                    <Avatar icon={avatarIcon} style={avatarStyle}/>
                </Link>
            }
        />
    );
};

CourseEnrolmentStatsCourseListItem.propTypes = {
    data: PropTypes.shape({
        courseId: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        code: PropTypes.string.isRequired,

        waiting: PropTypes.number,
        enrolled: PropTypes.number,
        completed: PropTypes.number,
        total: PropTypes.number
    })
};

export default CourseEnrolmentStatsCourseListItem;
